import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from './../services/auth.service';
import { IconByNameComponent } from '../../shared/components/icon-by-name.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../shared/components/loader.component';

@Component({
  selector: 'con-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconByNameComponent, ReactiveFormsModule, FormsModule, LoaderComponent],
})
export class LoginComponent {
  public email: string;
  public password: string;
  public hasErrors = false;
  public loading = false;

  constructor(private service: AuthService, private router: Router) {}

  onChange() {
    this.hasErrors = false;
  }

  login() {
    this.loading = true;
    this.hasErrors = false;
    this.service.login(this.email, this.password).subscribe(
      (res) => {
        this.loading = false;
      },
      (err) => {
        this.hasErrors = true;
        this.loading = false;
      }
    );
  }
}
